module.exports = __webpack_public_path__ + "media/images/web/favicon/ms-icon-150x150-3e130286b2c00172deabf519b99f078e.png";